import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-menu-intermediarios',
  templateUrl: './menu-intermediarios.component.html',
  styleUrls: ['./menu-intermediarios.component.css']
})
export class MenuIntermediariosComponent implements OnInit {
 public modelUser;
  constructor(private route: ActivatedRoute,private router: Router) { }

  ngOnInit() {
  
  var usuario=  localStorage.getItem('currentUsuario');  
    //ACA SE DEBE CONTROLAR LOS EMAILS ENVIADOS
    if(usuario==null)          
       this.router.navigate(['/intermediarios']);       
    else{
       this.modelUser=JSON.parse(usuario);             
    } 
  }
  
  cerrarSesion(){    
      
    localStorage.removeItem('currentUsuario');
    this.router.navigate(['/intermediarios']); 
  
  }

}



// WEBPACK FOOTER //
// ./src/app/components/general/menu-intermediarios/menu-intermediarios.component.ts